import {
  HUDDLE_INVITE,
  HUDDLE_SIGNAL,
  HUDDLE_SPEAKER_CHECK,
  HUDDLE_UPDATED,
} from '@common/constants/webSockets'
import {
  IHuddle,
  IHuddleInvite,
  IHuddleSignalDelivery,
  IHuddleSpeakerCheck,
} from '@common/interfaces/huddles'
import { takeEvery } from 'redux-saga/effects'
import { huddleStore } from '../../helpers/huddle/huddleStore'
import { nonFatal } from '../../helpers/redux'

/** One huddle frame, made non-fatal (see `nonFatal`); a frame with no data is dropped. */
const nonFatalHuddle = <T>(event: string, handle: (data: T) => void) =>
  nonFatal<{ type: string; data: T }>(`Huddle ${event}`, ({ data }) => {
    if (data) handle(data)
  })

/** Huddle frames from the socket, into the store the huddle session and buttons read. */
export function* feedHuddles() {
  yield takeEvery(
    HUDDLE_UPDATED,
    nonFatalHuddle<{ huddle?: IHuddle }>(HUDDLE_UPDATED, ({ huddle }) => {
      if (huddle) huddleStore.receive(huddle)
    }),
  )
  yield takeEvery(
    HUDDLE_SIGNAL,
    nonFatalHuddle<IHuddleSignalDelivery>(HUDDLE_SIGNAL, (signal) =>
      huddleStore.receiveSignal(signal),
    ),
  )
  yield takeEvery(
    HUDDLE_INVITE,
    nonFatalHuddle<IHuddleInvite>(HUDDLE_INVITE, (invite) => huddleStore.receiveInvite(invite)),
  )
  yield takeEvery(
    HUDDLE_SPEAKER_CHECK,
    nonFatalHuddle<IHuddleSpeakerCheck>(HUDDLE_SPEAKER_CHECK, (check) =>
      huddleStore.receiveSpeakerCheck(check),
    ),
  )
}
